import { bulb } from 'ionicons/icons'
import React, { useCallback, useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Button from '../../../components/actions/Button'
import { ModalContext } from '../../../contexts/ModalContext'
import { ObjectContext } from '../../../contexts/objectContext/ObjectContext'
import { trpc } from '../../../modules/trpc'
import OverViewCard from './OverviewCard'

const OurProductsCard: React.FC = () => {
	const { id } = useContext(ObjectContext)
	const { insertModal } = useContext(ModalContext)

	const history = useHistory()

	const { t } = useTranslation('pages_overview', { keyPrefix: 'ourProductsCard' })

	const handleClick = useCallback(() => {
		history.push('/contracts')
	}, [insertModal, history])

	const { data: productOffers } = trpc.synerall.productOffers.useQuery({ objectId: id })

	const biggestSavings = useMemo(() => {
		return 0
	}, [productOffers])

	if (biggestSavings <= 0) {
		return (
			<OverViewCard
				className='gradient'
				headerText={t('saastavaAlyenergia')}
				icon={bulb}
				onClick={handleClick}
				disableChevron
			>
				<img src='/assets/2024_logos/icon.png' className='icon' />
				<div className='showcase'>
					<div className='showcase-container'>
						<span className='title text-brand-secondary-100-light dark:text-brand-primary-200-dark'>
							{t('alternativeTitle')}
						</span>
						<span className='subtitle text-brand-secondary-100-light dark:text-brand-primary-200-dark'>
							{t('alternativeDesc')}
						</span>
					</div>
					<Button
						className='!bg-[linear-gradient(90deg,_#4caf50_0%,_#388e3c_100%)] dark:!bg-[linear-gradient(90deg,_#3ddc84_0%,_#34c98b_100%)]'
						onClick={handleClick}
					>
						{t('cta')}
					</Button>
				</div>
			</OverViewCard>
		)
	}

	return (
		<OverViewCard
			className='gradient'
			headerText={t('saastavaAlyenergia')}
			icon={bulb}
			onClick={handleClick}
			disableChevron
		>
			<img src='/assets/2024_logos/icon.png' className='icon' />
			<div className='showcase'>
				<div className='showcase-container'>
					<span className='title text-brand-secondary-100-light dark:text-brand-primary-200-dark'>
						{t('saasta')} <br /> {t('jopa')}{' '}
						<span className='text-highlight'>{biggestSavings.toFixed(2).replace('.', ',')} </span> €
					</span>

					<span className='subtitle text-brand-secondary-100-light dark:text-brand-primary-200-dark'>
						{t('peruste')}
					</span>
				</div>
				<Button
					className='!bg-[linear-gradient(90deg,_#4caf50_0%,_#388e3c_100%)] dark:!bg-[linear-gradient(90deg,_#3ddc84_0%,_#34c98b_100%)]'
					onClick={handleClick}
				>
					{t('cta')}
				</Button>
			</div>
		</OverViewCard>
	)
}

export default OurProductsCard
